import React, { useState, useEffect, useCallback } from "react";
import { useExamStatus } from "../ExamStatusContext";
import { useScoreTable } from "../ScoreContext";
import withResetOnNavigation from '../withResetOnNavigation';
import TestContainer from "../TestContainer";
import ZoomControls from "../ZoomControls";
import "../../../css/test6.css";
import answer from "../QA/Test6_q_a/answer";
import kensa6_example from "../QA/Test6_q_a/kensa6_example.jpg";

const Test6 = ({ onNext }) => {
  const { examStatus } = useExamStatus();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [inputValues, setInputValues] = useState({});
  const [isTest6Started, setIsTest6Started] = useState(false);
  const [notification, setNotification] = useState("");
  const [isTimeUp, setIsTimeUp] = useState(false);
  const score6 = React.useRef(0);
  const scoreTable = useScoreTable();

  const testDuration = 90;
  const totalQuestions = 24;

  useEffect(() => {
    const test6Status = localStorage.getItem("test6Status");
    if (examStatus === "検査中" && test6Status === "started") {
      localStorage.setItem("test6Status", "notStarted");
    }
  }, [examStatus]);

  const gradeTest = useCallback(() => {
    let calculatedScore = 0;
    for (let i = 0; i < totalQuestions; i++) {
      const userAnswer = inputValues[i + 1];
      const correctAnswer = answer[i + 1];
      if (userAnswer === correctAnswer) {
        calculatedScore += 1;
      }
    }

    score6.current = calculatedScore;
    localStorage.setItem("score6", calculatedScore);

    const normalizedScore = scoreTable.scoreTable6[String(calculatedScore)] ?? 0;
    const currentSScore = parseInt(localStorage.getItem("S_score"), 10) || 0;
    localStorage.setItem("S_score", currentSScore + normalizedScore);

    setNotification("検査を終了します！");
    setIsTimeUp(true);

    if (onNext) onNext(); // ← ここで次へ
  }, [inputValues, scoreTable, onNext]);

  const handleStartTest = () => {
    setIsTest6Started(true);
    localStorage.setItem("test6Status", "started");
  };

  const handleInputChange = (index, value) => {
    setInputValues((prev) => ({
      ...prev,
      [index]: value,
    }));
    if (value !== "-" && index === currentQuestionIndex + 1) {
      setCurrentQuestionIndex(index);
    }
  };

  const getImagePath = (index) =>
    require(`../QA/Test6_q_a/kensa6_${index + 1}.jpg`);

  const renderedQuestions = Array.from({ length: totalQuestions })
    .slice(0, currentQuestionIndex + 1)
    .map((_, index) => (
      <div key={index} className="test6-question">
        <p>問題 {index + 1}</p>
        <img
          src={getImagePath(index)}
          alt={`問題${index + 1}`}
          className="test6-image"
        />
        <select
          value={inputValues[index + 1] || "-"}
          onChange={(e) => handleInputChange(index + 1, e.target.value)}
        >
          <option value="-">-</option>
          <option value="A">A</option>
          <option value="B">B</option>
          <option value="C">C</option>
          <option value="D">D</option>
          <option value="E">E</option>
        </select>
      </div>
    ));

  if (!isTest6Started) {
    return (
      <div className="test6-container">
        <h1>検査4 - やり方の説明</h1>
        <p>
          左の図形を切り離して置き換えたとき、右の5つの図形の内の1つと同じ図形になります。それを答えて下さい。
          <br />
          図形はある部分が入れ替わったり、横回転や上下逆になっている場合もあります。よく注意して見て下さい。
        </p>
        <h2>例題</h2>
        <div className="example-container">
          <img
            src={kensa6_example}
            alt="例題6"
            className="test6-image-example"
          />
        </div>
        <button className="start-button" onClick={handleStartTest}>
          検査に進む
        </button>
      </div>
    );
  }

  return (
    <ZoomControls>
      <TestContainer
        title="検査4"
        isTimeUp={isTimeUp}
        notification={notification}
        renderedQuestions={renderedQuestions}
        manageTimer={true}
        gradeTest={gradeTest}
        testDuration={testDuration}
      />
    </ZoomControls>
  );
};

export default withResetOnNavigation(Test6);
